const ChooseLocation = ({navigate, createRule}) => {

    return (
        <>
        <div>
            Test
        </div>
        </>
        
    )
}

export default ChooseLocation